import { toast } from "react-toastify";
import { getMethod, postMethod, putMethod } from "../../api-service/api-service";
import { setLoading, setSelectedTalk, setTalks, setTotalPages, setTotalTalks } from "./talksSlice";

export const fetchAllTalksAction = (params) => async (dispatch) => {
    try {
        dispatch(setLoading(true));

        // Convert params object to URL search params
        const queryString = params ?
            Object.keys(params)
                .filter(key => params[key]) // Remove empty values
                .map(key => `${key}=${encodeURIComponent(params[key])}`)
                .join('&')
            : '';

        const url = `/talks${queryString ? `?${queryString}` : ''}`;
        const response = await getMethod(url);

        if (response.success === true) {
            dispatch(setTalks(response?.talks));
            dispatch(setTotalPages(response?.totalPages));
            dispatch(setTotalTalks(response?.totalTalks))
        } else {
            toast.error(response?.message || "Failed to fetch talks");
        }
        dispatch(setLoading(false));
    } catch (error) {
        console.log("Error: ", error);
        dispatch(setLoading(false));
    }
}

export const fetchTalkByIdAction = (data) => async (dispatch) => {
    try {
        const response = await getMethod(`/talks/${data}`);
        if (response.success === true) {
            dispatch(setSelectedTalk(response?.talk));
            toast.success("Talk Fetched Successfully");
        } else {
            toast.error(response?.message || "Failed to fetch talk");
        }
    } catch (error) {
        console.log("Error: ", error);
    }
}

export const updateTalkAction = (id, data) => async (dispatch) => {
    try {
        const response = await putMethod(`/talks/${id}`, data);
        if (response.success === true) {
            dispatch(setSelectedTalk(response?.talk));
            toast.success("Talk Updated Successfully");
        }
        return response;
    } catch (error) {
        console.log("Error: ", error);
    }
}

export const addNewTalkAction = (data) => async (dispatch) => {
    try {
        const response = await postMethod('/talks', data);
        if (response.success === true) {
            dispatch(setSelectedTalk(response?.talk));
        }
        return response;
    } catch (error) {
        console.log("Error: ", error);
    }
}

export const assignSummaryAction = (id, data) => async (dispatch) => {
    try {
        const response = await postMethod(`/talks/${id}/assign-summary`, data);
        if (response.success === true) {
            dispatch(setSelectedTalk(response?.talk));
            toast.success("Summary assignment successful");
        } else {
            toast.error(response?.message || "Failed to assign summary");
        }
        return response;
    } catch (error) {
        console.log("Error: ", error);
    }
};